/**
 * Messages for one area of the app (document 15, section 5.1), English and Arabic side by side.
 * Every key lives under `taxPages`; Arabic plurals have all six CLDR forms.
 */
import * as gstScreens from './taxPages/gstScreens.js';
import * as a from './taxPages/vatReports.js';
import * as b from './taxPages/vatReturns.js';
import * as c from './taxPages/einvoicing.js';
import * as d from './taxPages/gst.js';
import * as e from './taxPages/ewayBill.js';

export const en = {
  taxPages: { ...gstScreens.en, ...a.en, ...b.en, ...c.en, ...d.en, ...e.en },
};

export const ar = {
  taxPages: { ...gstScreens.ar, ...a.ar, ...b.ar, ...c.ar, ...d.ar, ...e.ar },
};
